<template>
    <main-container v-if="cguContent">
        <sep name="XL"></sep>
        <v-card class="content">
            <div v-html="cguContent"></div>
        </v-card>
        <sep name="L"></sep>
        <v-card v-if="user && !user.cguAccepted" class="actions">
            <v-checkbox v-model="checked" :label="dico.acceptance_checkbox" />
            <action name="main" @click="acceptCgu"> {{ dico.accept_cta }}</action>
        </v-card>
    </main-container>
</template>
<script>
import Vue from "vue";
import { EventBus } from "src/bus/eventBus";
import { Services } from "src/services/Services.js";
import loader from "src/mixins/loader";

export default Vue.extend({
    mixins: [loader],
    props: ["user"],
    data() {
        return {
            checked: false,
        };
    },
    computed: {
        dico() {
            return this.$privateDico.cgu;
        },
    },
    methods: {
        async acceptCgu() {
            if (this.checked) {
                const updatedUser = await Services.api.user.acceptCgu();
                const selectedConventionsPopulated = await Services.api.user.getMyConventions();

                if (updatedUser) {
                    EventBus.$emit("user:updated", {
                        ...updatedUser,
                        selectedConventionsPopulated,
                    });
                    await this.$router.push({ name: "account" });
                } else {
                    EventBus.$emit("alert:error", {
                        message: `Il faut cocher la case '${this.dico.acceptance_checkbox}' `,
                    });
                }
            }
        },
    },
    asyncComputed: {
        async cguContent() {
            // 528 page id in wordpress
            const response = await Services.wpApi.cguContent();
            return response.content.rendered;
        },
    },
});
</script>

<style lang="sass" scoped>
.cgu
    height: 100%
    display: flex
    flex-direction: column

.content
    margin: auto
    padding: 16px 48px

.actions
    margin: auto
    padding: 0 48px
    display: flex
    align-items: center
    justify-content: space-between

.has-text-align-center
    text-align: center

.has-text-align-left
    text-align: left
::v-deep
    p,ul,ol
        margin-top: 16px
        margin-bottom: 16px

    h2
        margin-top: 64px
        margin-bottom: 32px

    h3
        margin-top: 48px
        margin-bottom: 24px

    h4
        margin-top: 32px
        margin-bottom: 16px

    h5, h6
        margin-top: 16px
        margin-bottom: 16px
</style>
